import { stripUnsavedImages } from "./blogMedia.js";

const KEY = "blog.compose.draft.v1";

export const composeDraftSlot = (id) => String(id || "").trim() || "new";

const readAll = () => {
    try {
        return JSON.parse(localStorage.getItem(KEY) || "{}") || {};
    } catch {
        return {};
    }
};

const writeAll = (all) => {
    try {
        localStorage.setItem(KEY, JSON.stringify(all));
        return true;
    } catch {
        return false;
    }
};

const messagesOf = (rows) => (Array.isArray(rows) ? rows : [])
    .map((row) => ({
        role: row?.role === "assistant" ? "assistant" : "user",
        content: String(row?.content || "").trim(),
    }))
    .filter((row) => row.content)
    .slice(-24);

export const readComposeDraft = (id) => {
    const row = readAll()[composeDraftSlot(id)];
    if (!row || typeof row !== "object") return null;
    return {
        title: String(row.title || ""),
        body: String(row.body || ""),
        originalBody: String(row.originalBody || ""),
        writerMessages: messagesOf(row.writerMessages),
        writerApplied: Boolean(row.writerApplied),
        writerOpen: row.writerOpen !== false,
        savedAt: String(row.savedAt || ""),
    };
};

export const writeComposeDraft = (id, patch) => {
    const slot = composeDraftSlot(id);
    const prev = readAll()[slot] || {};
    const next = {
        ...prev,
        ...patch,
        savedAt: new Date().toISOString(),
    };
    if (patch.body != null) next.body = stripUnsavedImages(patch.body);
    if (patch.writerMessages) next.writerMessages = messagesOf(patch.writerMessages);
    return writeAll({ ...readAll(), [slot]: next });
};

export const clearComposeDraft = (id) => {
    const all = readAll();
    delete all[composeDraftSlot(id)];
    return writeAll(all);
};
